/* unplugin-vue-components disabled */import script from "./KfServicerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KfServicerModal.vue?vue&type=script&setup=true&lang=js"

import "./KfServicerModal.vue?vue&type=style&index=0&id=bbae1844&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbae1844"]])

export default __exports__